import React, { useEffect, useState } from "react";
import VerificationPopUp from "../../VerificationPop/VerificationPopUp";
import Popup from "../../../components/popup/Popup";
import {
  AdminDetailFieldLabel,
  AdminHeaderAction,
  adminWizardInputClasses,
} from "../../AdminDashboard/shared/adminUx";
import {
  CUSTOMER_WIZARD_CONTENT_WIDE_CLASS,
  CUSTOMER_FORM_ACTION_ROW_END_CLASS,
} from "../shared/customerLayoutSpec";

const Mobile = () => {
  const [verify, setVerify] = useState(false);
  const [ShowCrossButton, setShowCrossButton] = useState(true);

  useEffect(() => {
    if (verify) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = "auto";
    }
  }, [verify]);

  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className={`${CUSTOMER_WIZARD_CONTENT_WIDE_CLASS} space-y-5`}>
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="current-mobile">Mobile number</AdminDetailFieldLabel>
            <input
              id="current-mobile"
              type="tel"
              placeholder="Mobile number"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className="space-y-1">
            <AdminDetailFieldLabel htmlFor="new-mobile">New mobile number</AdminDetailFieldLabel>
            <input
              id="new-mobile"
              type="tel"
              placeholder="Please enter your new mobile number"
              className={`${adminWizardInputClasses(false)} lg:bg-pastalblue`}
            />
          </div>
          <div className={CUSTOMER_FORM_ACTION_ROW_END_CLASS}>
            <AdminHeaderAction type="button" onClick={() => setVerify(true)}>
              Verify
            </AdminHeaderAction>
          </div>
        </div>
      </form>
      {verify && (
        <Popup setTrigger={() => setVerify(false)} ShowCrossButton={ShowCrossButton}>
          <VerificationPopUp
            closePopup={() => setVerify(false)}
            firstMainHeading="Mobile verification"
            label="Varification code"
            placeholder="Enter the 5-digit code here"
            firstP="Enter the verification code we've just sent to your phone. This helps us ensure your account stays secure and confirms your ownership."
            secondMainHeading="Mobile verified"
            secondP="Your phone number has been verified! You're all set to receive notifications directly to your device. Thanks for securing your account."
            buttonText="Submit"
          />
        </Popup>
      )}
    </>
  );
};

export default Mobile;
